import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import type { Player } from "../player";
import { BlackHoleProjectile } from "../projectiles/blackHoleProjectile";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { Weapon } from "../weapon";

export class BlackHoleGun extends Weapon {
	static key = "BlackHoleGun";

	constructor(owner: Player) {
		super(owner, 0, true);
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_PLASMAGUN));
		const spawnPos = this.owner.xy.add(directionDelta(direction));
		this.shotProjectile(board, new BlackHoleProjectile(spawnPos, direction));
	}

	static deserialize(_data: any, owner: Player): BlackHoleGun {
		return new BlackHoleGun(owner);
	}
}
